import { render } from "./TabGuard.vue?vue&type=template&id=92d1105a&lang=pug"
import script from "./TabGuard.vue?vue&type=script&lang=js"
export * from "./TabGuard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__